import { removeEmptyValues } from "./removeEmptyValues";
import { convertDateForRequest } from "./convertDateForRequest";

interface FromJsonToUrlencodedProps {
  data: any;
  isDateComvert?: boolean;
}

const typeDateProperty = ["Start", "Finish"];
const excludeKeys = ["ThemeKey", "SearchText"];

export const fromJsonToUrlencoded = ({
  data,
  isDateComvert = true,
}: FromJsonToUrlencodedProps): string => {
  const formBody: any[] = [];
  for (const property in removeEmptyValues(data)) {
    if (!excludeKeys.includes(property)) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(
        typeDateProperty.includes(property) && isDateComvert
          ? convertDateForRequest(data[property])
          : data[property],
      );
      formBody.push(encodedKey + "=" + encodedValue);
    }
  }
  return formBody.join("&") as string;
};
